import { render, staticRenderFns } from "./TabUnite.vue?vue&type=template&id=566533d4"
import script from "./TabUnite.vue?vue&type=script&lang=js"
export * from "./TabUnite.vue?vue&type=script&lang=js"
import style0 from "./TabUnite.vue?vue&type=style&index=0&id=566533d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports